import React, { useEffect, useState } from 'react';
import Loader from '../../../../_common/Loader/Loader';
import Table from '../../../../_common/Tables/Table';
import classes from '../../dashboard.module.scss';
import Api from '../../../../../api/api';

const STATS = [
  { label: '#1 Medication', key: 'medication' },
  { label: '#1 State', key: 'state' },
  { label: '#1 Payor', key: 'payor' },
  { label: '#1 Specialty', key: 'specialty' },
  { label: '#1 Hub', key: 'hub' },
];

const TABLE_HEADER = [
  { name: 'Category', path: 'label' },
  { name: 'Value', path: 'value' },
];

const buildRows = (data) => STATS.map((stat) => ({
  label: stat.label,
  value: data[stat.key] ?? '-',
}));

const QuickStatsTable = ({ requestData }) => {
  const [quickStatsData, setQuickStatsData] = useState(null);
  const [loading, loadingToggle] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        loadingToggle(true);

        const { data } = await Api.getQuickStats(requestData);

        setQuickStatsData(data);
        loadingToggle(false);
      } catch (e) {
        console.warn(e);
      }
    })();
  }, [requestData]);

  const isEmpty = STATS.every((b) => !quickStatsData?.[b.key]);
  const rows = isEmpty ? [] : buildRows(quickStatsData);

  return (
    <div
      className={classes.chart_kpi_wrapper}
      style={{
        background: '#fff',
        borderRadius: 12,
        padding: 16,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <p style={{
        margin: '0 0 12px', fontWeight: 700, fontSize: 15, color: '#111827',
      }}
      >
        Quick stats
      </p>

      {loading
        ? <Loader className={classes.chart_kpi_wrapper_loader} />

        : <Table data={rows} header={TABLE_HEADER} />}
    </div>
  );
};

export default QuickStatsTable;
